const usersReducers = {
  admin: 'Administrador',
  analyst: 'Analista de Documentación',
  contractor: 'Tercera empresa'
};

export default usersReducers;
